var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "maskzxcasdqwe",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.798C4.85091 2.798 2.29808 5.35084 2.29808 8.49992C2.29808 11.649 4.85091 14.2018 8 14.2018C11.1491 14.2018 13.7019 11.649 13.7019 8.49992C13.7019 5.35084 11.1491 2.798 8 2.798ZM1.33333 8.49992C1.33333 4.81802 4.3181 1.83325 8 1.83325C11.6819 1.83325 14.6667 4.81802 14.6667 8.49992C14.6667 12.1818 11.6819 15.1666 8 15.1666C4.3181 15.1666 1.33333 12.1818 1.33333 8.49992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.54383C8.2664 5.54383 8.48237 5.75979 8.48237 6.0262V8.49992C8.48237 8.76633 8.2664 8.98229 8 8.98229C7.73359 8.98229 7.51762 8.76633 7.51762 8.49992V6.0262C7.51762 5.75979 7.73359 5.54383 8 5.54383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51762 10.9736C7.51762 10.7072 7.73359 10.4913 8 10.4913H8.00649C8.2729 10.4913 8.48886 10.7072 8.48886 10.9736C8.48886 11.24 8.2729 11.456 8.00649 11.456H8C7.73359 11.456 7.51762 11.24 7.51762 10.9736Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#maskzxcasdqwe)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "matrix(-1 0 0 1 16 0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.ee0c36dbde74c3fc753a4ba2f0dbe0f4.svg";
export { ForwardRef as ReactComponent };